import * as types from "@/common/vuex.const";

export default {
  namespaced: true,
  state: {
    //修改的表单参数，用于对比数据是否变化
    vuex_dataForm: {},
    //当前navagation menus 点击的市场
    vuex_firm: {}
  },
  mutations: {
    [types.UPDATE_VERSION_DATA_FORM]: (state, data) => {
      state.vuex_dataForm = data;
    },
    [types.UPDATE_VERSION_FIRM]: (state, data) => {
      state.vuex_firm = data;
    }
  }
};
